import { z } from 'zod';

/**
 * Validation schema for register/lab-orders. The Razor form only marked the lab
 * choice `required`; the mentor opt-in is optional and the POST tolerates it being
 * unanswered.
 */
export const labOrdersSchema = z.object({
    labChoice: z.string().min(1, 'Please select how you would like to complete your labs'),
    connectToDonorIsDesired: z.string(),
});
